{
  "id": "oceanus",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Oceano",
    "en": "Oceanus"
  },
  "icon": "gods/oceanus",
  "portrait": "gods/oceanus-portrait",
  "age": "classical",
  "freeUnitsOnAgeUp": {
    "caladria": 1
  },
  "unlocks": ["caladria", "servant", "bite-of-the-shark", "weightless-mace", "frontline-heroics"],
  "powers": ["carnivora"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml ClassicalAgeOceanus)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 caladria at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Carnivora (cooldown 180 s). Also creates 1 Servant at a Dock (only if a Dock exists; not in freeUnitsOnAgeUp)."
  }
}
